<template>
  <b-modal
    class="modal-participants"
    id="modal-participants"
    hide-footer
    centered
    hide-header
    size="l"
  >
    <div class="view-header p-2 d-flex justify-content-between">
      <div>
        <h5>{{ text }}</h5>
      </div>
      <div>
        <b-button class="button p-0" variant="light" @click="closeModalParticipants">
          <h5><b-icon icon="x"></b-icon></h5>
        </b-button>
      </div>
    </div>
    <div class="content mt-2">
      <div class="detail">
        <div class="detail-info row justify-content-between d-flex text-muted">
          <div class="info col text-muted font-weight-bold">
            Total
          </div>
          <div class="info col text-right font-weight-bold">
            {{ totalEmployeeIds }}
          </div>
        </div>
        <div class="divider"></div>
        <div class="detail-info row justify-content-between d-flex text-muted">
          <ul class="info col text-muted">
            <li v-for="participant in uniqueParticipants" :key="participant.employeeId">
              {{ getFullNameByEmployeeId(participant.employeeId) }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: () => {}
    },
    eventTraining: {
      type: Object,
      default: () => {}
    },
    employee: {
      type: Array,
      default: () => []
    },
    listParticipant: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    totalEmployeeIds() {
      const filteredParticipants = this.listParticipant.filter(participant => participant.eventId === this.eventTraining.id)
      return filteredParticipants.length
    },
    uniqueParticipants() {
      const filteredParticipants = this.listParticipant.filter(participant => participant.eventId === this.eventTraining.id)
      const uniqueEmployeeIds = [...new Set(filteredParticipants.map(participant => participant.employeeId))]
      return uniqueEmployeeIds.map(employeeId => filteredParticipants.find(participant => participant.employeeId === employeeId))
    }
  },
  methods: {
    closeModalParticipants() {
      this.$bvModal.hide('modal-participants')
    },
    getFullNameByEmployeeId(employeeId) {
      const employeeData = this.employee.find(emp => emp.id === employeeId)
      return employeeData ? employeeData.fullName : employeeId
    }
  }
}
</script>

<style>
*{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.detail-info{
  padding: 0 17px 0 17px;
  .info{
    padding-top: 7px;
    padding-bottom: 7px;
    vertical-align: baseline;

    a{
      color: blue !important
    }
  }
}

.b-icon.bi{
  color: black;
}
.content{
  font-size: 16px;
}

.detail-info ul.info li {
    margin-bottom: 10px;
  }

.view-header{
  border-bottom: 1px solid grey;
}

.button{
  color: white;
  background-color: transparent;
  border: none;
}

.badge {
  display: inline-block;
  padding: 0.5em 0.6em;
  font-size: 70%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>
